export const ORDER_STATUS_LABELS = {
  CREATED: 'Создан', PAID: 'Оплачен', ASSEMBLING: 'Собирается', SHIPPED: 'Передан в доставку',
  DELIVERED: 'Доставлен', CANCELLED: 'Отменён', REFUNDED: 'Возврат выполнен',
  new: 'Новый', processing: 'В обработке', shipped: 'Передан в доставку', delivered: 'Доставлен',
  cancelled: 'Отменён', returned: 'Возвращён',
};

export const FULFILLMENT_LABELS = {
  waiting: 'Ожидает обработки', ASSEMBLING: 'Собирается', assembling: 'Собирается',
  shipped: 'Передан в доставку', DELIVERED: 'Доставлен', delivered: 'Доставлен',
  cancelled: 'Отменён', CANCELLED: 'Отменён',
};

export function orderStatusLabel(status) { return ORDER_STATUS_LABELS[status] || 'Статус уточняется'; }
export function customerOrderStatusLabel(status) {
  return status === 'CREATED' ? 'Ожидает оплаты' : orderStatusLabel(status);
}
export function fulfillmentLabel(status) { return FULFILLMENT_LABELS[status] || (status ? 'Статус уточняется' : 'Не указан'); }

export function getOrderId(order) { return order?.customerOrderId || order?.customer_order_id || order?.id; }
export function getOrderItems(order) {
  return order?.items || order?.orderItems || order?.sellerOrders?.flatMap((slice) => slice.items || []) || [];
}
export function itemTitle(item) { return item.product_title || item.productTitle || item.product?.title || item.orderItem?.product?.title || item.title || 'Товар'; }
export function itemVariant(item) { return item.variant_size || item.variantSize || item.variant?.size || item.orderItem?.variant?.size || item.variant?.name; }
export function isCompletedOrder(order) { return ['DELIVERED', 'CANCELLED', 'REFUNDED', 'RETURNED'].includes(String(order.status).toUpperCase()) || String(order.fulfillmentStatus).toUpperCase() === 'DELIVERED'; }
export function itemPrice(item) { return Number(item.price ?? item.unitPrice ?? item.product_price ?? 0); }
export function itemQuantity(item) { return Number(item.quantity || 1); }
export function orderTotal(order) {
  return Number(order?.totalAmount ?? order?.total_amount ?? order?.amount ??
    getOrderItems(order).reduce((sum, item) => sum + itemPrice(item) * itemQuantity(item), 0));
}
export function orderGrandTotal(order) {
  return orderTotal(order) + Number(order?.deliveryCost ?? order?.delivery_cost ?? 0);
}
export function orderDate(order) {
  const value = order?.createdAt || order?.created_at;
  return value ? new Date(value).toLocaleDateString('ru-RU') : 'Дата уточняется';
}
export function canCancelOrder(order) {
  return ['CREATED', 'PAID'].includes(order?.status) && (order.canCancelCollection ?? (order.fulfillmentStatus === 'waiting'));
}
export function refundLabel(status) {
  return {
    PENDING: 'Возврат оформлен', PROCESSING: 'Возврат обрабатывается',
    SUCCEEDED: 'Деньги возвращены', FAILED: 'Не удалось автоматически выполнить возврат',
  }[status];
}

export function customerOrderError(error, action = 'загрузить заказ') {
  const status = error?.response?.status;
  if (status === 401) return 'Войдите в аккаунт, чтобы просматривать заказы.';
  if (status === 403) return 'У вас нет доступа к этому заказу.';
  if (status === 404) return 'Заказ не найден.';
  if (status === 409 && action === 'отменить заказ') return 'Заказ уже передан в обработку и не может быть отменён.';
  if (status >= 500 || !error?.response) return 'Не удалось связаться с сервером. Попробуйте ещё раз.';
  return `Не удалось ${action}. Попробуйте ещё раз.`;
}
